(function () {
  function placeInstagramAfterFootball() {
    var footballBlocks = document.querySelectorAll('.sfg-football-customization');

    footballBlocks.forEach(function (football) {
      var productInfo = football.closest('.product__info-container') || document;
      var instagram = productInfo.querySelector('.sfg-instagram-username');
      if (!instagram) return;

      var footballStyle = football.nextElementSibling;
      var insertionPoint = footballStyle && footballStyle.tagName === 'STYLE' ? footballStyle : football;

      if (insertionPoint.nextElementSibling !== instagram) {
        insertionPoint.insertAdjacentElement('afterend', instagram);
      }
    });
  }

  function runSfgProductPolish() {
    placeInstagramAfterFootball();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runSfgProductPolish);
  } else {
    runSfgProductPolish();
  }

  document.addEventListener('shopify:section:load', runSfgProductPolish);
})();
